import { render } from "./ISO.vue?vue&type=template&id=5f66d6da"
import script from "./ISO.vue?vue&type=script&lang=ts"
export * from "./ISO.vue?vue&type=script&lang=ts"

const cssModules = script.__cssModules = {}
import style0 from "./ISO.vue?vue&type=style&index=0&id=5f66d6da&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script